import { render } from "./conferenceDetail.vue?vue&type=template&id=ee7127bc&scoped=true"
import script from "./conferenceDetail.vue?vue&type=script&lang=js"
export * from "./conferenceDetail.vue?vue&type=script&lang=js"

import "./conferenceDetail.vue?vue&type=style&index=0&id=ee7127bc&lang=scss&scoped=true"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee7127bc"]])

export default __exports__